<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-if="!isLoading" class="profile">
      <div class="container">
        <div class="centered">
          <div>
            <img
              width="100%"
              src="@/assets/svg/Ardunic Account page-111.svg"
              alt="login"
            />
          </div>
        </div>
        <div class="centered mt-3">
          <p style="font-size: 28px">{{ user.name }}</p>
        </div>
        <div class="centered mt-4">
          <div>
            <div class="profile-box mr-2">
              <img src="@/assets/svg/Ardunic Elements-08.svg" alt="..." />
            </div>
            <div class="w-full centered">
              <router-link
                to="/orders"
                style="font-size: 25px;font-family: 'Tajawal', sans-serif;"
                class="text-center mt-2"
                >Your Orders</router-link
              >
            </div>
          </div>
          <div>
            <div class="profile-box mx-2">
              <img src="@/assets/svg/Ardunic Account page-333.svg" alt="..." />
            </div>
            <div class="w-full centered">
              <a
                href="#"
                style="font-size: 25px"
                class="text-center mt-2 disabled__href "
                disabled
              >
                Login & security
              </a>
            </div>
          </div>
          <div>
            <div class="profile-box ml-2">
              <img src="@/assets/svg/Ardunic Account page-444.svg" alt="..." />
            </div>
            <div class="w-full centered">
              <a
                href="#"
                style="font-size: 25px"
                class="text-center mt-2 disabled__href "
                disabled
              >
                Address info
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import router from "../router";
import axios from "axios";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      user: "",
      isLoading: true,
    };
  },
  created() {
    axios
      .get("https://api.ardunic.com/v1/user", {
        headers: {
          access_token: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.user = res.data.data;
        this.$store.dispatch("initProfile", res.data.data);
        this.isLoading = false;
      });
  },
  methods: {
    navigate(slug) {
      router.push({ path: `/product/${slug}` });
      // console.log(slug);
    },
  },
};
</script>

<style scoped>
.centered {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile {
  margin: 120px 40px;
}

#circle {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 50%;
  width: 160px;
  height: 160px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-box {
  height: 15rem;
  border-radius: 15px;
  width: 15rem;
  border: 2px solid #b3b3b3;
  align-items: center;
  display: flex;
  justify-content: center;
}
.profile-box img {
  width: 100%;
  padding: 60px;
}

.disabled__href {
  color: #858585;
  cursor: not-allowed;
}
</style>
